import styled from 'styled-components'
import { VALIDITY_BG, VALIDITY_TEXT } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`

interface QuotaTextProps {
  $fontSize: number
}

export const QuotaText = styled.span<QuotaTextProps>`
  font-family: ${INTER.medium};
  font-size: ${props => props.$fontSize}px;
  color: linear-gradient(-45, #3C53D7 0%, #1A1B6E 100%);
`

interface ValidityBadgeProps {
  $fontSize: number
}

export const ValidityBadge = styled.span<ValidityBadgeProps>`
  background-color: ${VALIDITY_BG};
  font-family: ${INTER.regular};
  font-size: ${props => props.$fontSize}px;
  color: ${VALIDITY_TEXT};
  padding: 4px;
  border-radius: 5px;
`
